import { Record } from 'immutable'

import type { DeepNullable } from '@albacross/types'

import type { Permissions, RoleWithPermissions } from '../api/Customer'
import type { Role } from '../store/Customer'

export const PermissionsRecord = Record<Permissions>({
  abm: false,
  tags: false,
  leads: false,
  pages: false,
  users: false,
  domains: false,
  support: false,
  payments: false,
  segments: false,
  workflows: false,
  notifications: false,
  'profile.activity': false,
  'profile.contacts': false,
  'profile.overview': false,
  'settings.account': false,
  'settings.company': false,
  'settings.security': false,
  'leads.exports.csv': false,
  'settings.integrations': false,
  'leads.exports.workflow': false,
  'profile.contacts.reveal': false,
  revealApi: false,
  signals: false,
  homeScreen: false,
  outreach: false,
  'outreach.sender': false,
})

export const RoleRecord = Record<DeepNullable<Role>>({
  id: null,
  name: '',
  permissions: PermissionsRecord(),
  customerId: null,
})

export const roleFromServer = (x: RoleWithPermissions) =>
  RoleRecord({
    ...x,
    customerId: x.customer_id,
    permissions: PermissionsRecord(x.permissions),
  })
